export enum ENOPTrialProgramName {
  ENHANCE = 'ENHANCE',
  DENOVO = 'DENOVO',
}
